export default "__VITE_ASSET__d3b5b5e0__"